/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./EditSurvey.module.css";
import {
  createStyles,
  Dialog,
  FormControlLabel,
  IconButton,
  makeStyles,
  Switch,
  Theme,
  withStyles,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  DialogProps,
} from "@material-ui/core";
import { AppState } from "../../root/RootReducer";
import PuiButton from "../elements/PuiButton";
import PuiTypography from "../elements/PuiTypography";
import ErrorIcon from "@material-ui/icons/Error";
import { Video } from "../../common/video/models/Video";
import AddSurveyModal from "./AddSurvey";
import {
  Survey,
  UpdateVideoSurveyIF,
  DeleteSurveyIF,
} from "../../models/survey";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import AddIcon from "@material-ui/icons/Add";
import {
  GetAllSurvey,
  GetSurveyById,
  UpdateSurvey,
} from "../../store/actions/SurveyActions";
import { useNavigate } from "react-router-dom";
import EditSurveyDetail from "./EditSurveyDetail";
import PuiMessage from "../widgets/PuiMessage";
import { stringifyVideoTimeWithColons } from "../../common/video/util/videoTimeStrings";

interface EditSurveyProps {
  videoId: number;
  video: Video;
  // モーダルを閉じる
  CloseEditVideoTab: () => void;
  isSaved: boolean;
  setIsSaved: (isSaved: boolean) => void;
  ForceCloseEditVideoModal: () => void;
}

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    dialogTitle: {
      padding: "16px 24px 16px 10px",
    },
    dialogContent: {
      marginLeft: "53px",
      padding: "0",
    },
    dialogActions: {
      marginTop: "15px",
      marginBottom: "10px",
      marginRight: "10px",
    },
  })
);

function EditSurveyModal({
  videoId,
  video,
  CloseEditVideoTab,
  isSaved,
  setIsSaved,
  ForceCloseEditVideoModal,
}: EditSurveyProps) {
  const RedSwitch = withStyles({
    switchBase: {
      color: "var(--red)",
      "&$checked": {
        color: "var(--red)",
      },
      "&$checked + $track": {
        backgroundColor: "var(--red)",
      },
    },
    checked: {},
    track: {},
  })(Switch);

  const { userInfo, videos, SurveyList, allSurveyList } = useSelector(
    (state: AppState) => ({
      userInfo: state.user.userInfo,
      videos: state.video.videos,
      SurveyList: state.Survey.SurveyList,
      allSurveyList: state.Survey.allSurveyList,
    })
  );

  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useNavigate();

  // アンケート情報取得
  useEffect(() => {
    if (userInfo) {
      dispatch(GetSurveyById(Number(userInfo.id), video.id));
      dispatch(GetAllSurvey());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 表示・編集用リストの作成
  const [updateVideoSurveyList, UpdateVideoSurvey] = useState<Survey[]>([]);
  const [updateAllSurveyList, UpdateAllSurvey] = useState<Survey[]>([]);
  const [updateSurveyList, UpdateSurveyList] = useState<Survey[]>([]);
  const [deleteSurveyIdList, DeleteSurveyId] = useState<DeleteSurveyIF[]>([]);

  useEffect(() => {
    UpdateVideoSurvey(SurveyList);
    if (SurveyList.length > 0) {
      ChangeSlidePublic(SurveyList[0].isPublic);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SurveyList]);

  useEffect(() => {
    if (deleteSurveyIdList.length > 0) {
      UpdateAllSurvey(
        allSurveyList.filter(
          (v) =>
            deleteSurveyIdList
              .map((item) => item["surveyId"])
              .includes(v.surveyId) === false
        )
      );
    } else {
      UpdateAllSurvey(allSurveyList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSurveyList]);

  // ビデオURL
  const sourceUrl = video.sourceUrl;
  const videoRef = useRef<HTMLVideoElement>(null);

  // 公開・非公開切り替え
  const [isPublic, ChangeSlidePublic] = useState(false);
  const SwitchPublicState = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    console.log("SwitchPublicState start");
    ChangeSlidePublic(checked);
    setIsSaved(false);
  };

  // ビデオに登録するアンケートの削除
  const DeleteVideoSurvey = (index: number) => {
    console.log("DeleteVideoSurvey start");
    const temp = [...updateVideoSurveyList];
    temp.splice(index, 1);
    UpdateVideoSurvey(temp);
    setIsSaved(false);
  };

  // ビデオに登録するアンケートの追加
  const AddSurveyToVideo = (index: number) => {
    console.log("AddSurveyToVideo start");
    if (videoRef) {
      if (videoRef.current) {
        // 同じ時刻に複数件のアンケートを登録できないよう制限
        const setMs = Math.floor(videoRef.current.currentTime) * 1000;
        const duplicateCheckIndex = updateVideoSurveyList.findIndex(
          ({ surveyStartMillis }) => surveyStartMillis === setMs
        );
        if (duplicateCheckIndex === -1) {
          const copy: Survey[] = JSON.parse(
            JSON.stringify(updateAllSurveyList)
          );
          const addSurvey = copy[index];
          addSurvey.surveyStartMillis = setMs;

          const temp = updateVideoSurveyList.concat(addSurvey);
          temp.sort(function (a, b) {
            return a.surveyStartMillis - b.surveyStartMillis;
          });

          UpdateVideoSurvey(temp);
          setIsSaved(false);
        } else {
          ChangeErrorMessageVisiblity(true);
        }
      }
    }
  };

  // 同じ時刻に複数件のアンケートを登録できないよう制限するメッセージ
  const [isVisibleErrorMessage, ChangeErrorMessageVisiblity] = useState(false);
  const CloseErrorMessage = () => {
    ChangeErrorMessageVisiblity(false);
  };

  // アンケート編集
  const UpdateSurveyDetail = (surveyIndex: number, surveyDetail: Survey) => {
    const tempAll = [...updateAllSurveyList];
    tempAll[surveyIndex] = surveyDetail;
    UpdateAllSurvey(tempAll);
    // 重複して編集した場合、上書きする
    const duplicateCheckIndex = updateSurveyList.findIndex(
      ({ surveyId }) => surveyId === surveyDetail.surveyId
    );
    if (duplicateCheckIndex === -1) {
      updateSurveyList.push(surveyDetail);
    } else {
      updateSurveyList[duplicateCheckIndex] = surveyDetail;
    }
    setIsSaved(false);
    console.log(updateSurveyList);
  };

  // アンケート削除の場合、メッセージ表示
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteIndex, ChangeDeleteIndex] = useState(-1);

  const ClickDeleteSurvey = (index: number) => {
    console.log("ClickDeleteSurvey start");
    setOpenDialog(true);
    ChangeDeleteIndex(index);
  };

  const handleCloseDialog:DialogProps['onClose'] = (evt, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    setOpenDialog(false);
  };

  const handleCancel = () => {
    setOpenDialog(false);
  };

  // アンケート削除して、メッセージを消去する
  const DeleteSurvey = () => {
    console.log("DeleteSurvey start");
    deleteSurveyIdList.push({
      surveyId: updateAllSurveyList[deleteIndex].surveyId,
    });
    const tempAll = [...updateAllSurveyList];
    tempAll.splice(deleteIndex, 1);
    UpdateAllSurvey(tempAll);

    const temp = [...updateVideoSurveyList];
    const tempIndex = temp.findIndex(
      ({ surveyId }) => surveyId === updateAllSurveyList[deleteIndex].surveyId
    );
    if (tempIndex >= 0) {
      temp.splice(tempIndex, 1);
      UpdateVideoSurvey(temp);
    }
    setIsSaved(false);
    handleCancel();
    ChangeDeleteIndex(-1);
  };

  // キャンセルボタン
  const ClickCancelButton = () => {
    console.log("ClickCancelButton start");
    CloseEditVideoTab();
  };

  // 編集完了ボタン
  const ClickDoneButton = () => {
    const updateVideoList: UpdateVideoSurveyIF[] = [];
    if (userInfo) {
      updateVideoSurveyList.map(function (row) {
        updateVideoList.push({
          surveyId: row.surveyId,
          surveyStartMillis: row.surveyStartMillis,
          isPublic: isPublic,
        });
        return null;
      });
      dispatch(
        UpdateSurvey({
          userId: Number(userInfo.id),
          videoId: video.id,
          updVideoSurveyList: updateVideoList,
          delSurveyIdList: deleteSurveyIdList,
          updSurveyList: updateSurveyList,
        })
      );
    }
    setIsSaved(true);
    ForceCloseEditVideoModal();
    UpdateVideoSurvey([]);
    UpdateAllSurvey([]);
    UpdateSurveyList([]);
    DeleteSurveyId([]);
    history("/videos");
  };

  return (
    <>
      <div className={styles.root}>
        <div className={styles.title} style={{ display: "flex" }}>
          <PuiTypography size={20} bold>
            {videos[videoId].title}
          </PuiTypography>
          <FormControlLabel
            label={isPublic ? "公開" : "非公開"}
            style={{ marginTop: "-15px" }}
            control={
              <RedSwitch
                checked={isPublic}
                className={styles.switch}
                onChange={SwitchPublicState}
                name="isPublic"
              />
            }
          />
        </div>
        <div className={styles.videoSurvey}>
          <PuiTypography>
            登録済みアンケート（{" "}
            {updateVideoSurveyList ? updateVideoSurveyList.length : 0} / 5）
          </PuiTypography>
          {updateVideoSurveyList.length > 0 && (
            <ul className={styles.videolist}>
              {updateVideoSurveyList.map((row, index) => (
                <li className={styles.videoSurveyList} key={index}>
                  <div style={{ width: "80px" }}>
                    <PuiTypography>
                      {stringifyVideoTimeWithColons(
                        row.surveyStartMillis,
                        true
                      )}
                    </PuiTypography>
                  </div>
                  <PuiTypography>{row.title}</PuiTypography>
                  <IconButton
                    onClick={() => DeleteVideoSurvey(index)}
                    className={styles.deleteIcon}
                    style={{ position: "absolute", top: "0" }}
                  >
                    <HighlightOffIcon style={{ color: "var(--gray-85)" }} />
                  </IconButton>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className={styles.video}>
          <PuiTypography>アンケート挿入時間の設定</PuiTypography>
          <video
            id="videoPlayer"
            className={
              videoRef.current &&
              videoRef.current.videoWidth / videoRef.current.videoHeight >= 1
                ? styles.LandscapeVideo
                : styles.PortraitVideo
            }
            controls
            width="100%"
            ref={videoRef}
            key={sourceUrl}
            controlsList="nodownload"
            disablePictureInPicture
            style={{ display: "block" }}
          >
            <source src={sourceUrl} type="video/mp4" />
          </video>
        </div>

        <div className={styles.surveyList}>
          <PuiTypography>アンケート一覧</PuiTypography>
          <ul className={styles.list}>
            {updateAllSurveyList.length > 0 &&
              updateAllSurveyList.map((row, index) => (
                <li className={styles.videoSurveyList} key={index}>
                  <div
                    style={{
                      visibility:
                        updateVideoSurveyList.length > 4 ? "hidden" : "visible",
                    }}
                  >
                    <IconButton
                      onClick={() => AddSurveyToVideo(index)}
                      className={styles.deleteIcon}
                    >
                      <AddIcon style={{ color: "var(--red)" }} />
                    </IconButton>
                  </div>
                  <PuiTypography>{row.title}</PuiTypography>
                  <div className={styles.surveyListIcon}>
                    <EditSurveyDetail
                      setIsSaved={setIsSaved}
                      surveyIndex={index}
                      surveyDetail={row}
                      UpdateSurveyDetail={UpdateSurveyDetail}
                    />
                    <IconButton
                      onClick={() => ClickDeleteSurvey(index)}
                      className={styles.icon}
                      style={{ position: "relative", float: "right" }}
                    >
                      <HighlightOffIcon style={{ color: "var(--gray-85)" }} />
                    </IconButton>
                  </div>
                </li>
              ))}
            <li
              style={{
                height: "40px",
                borderBottom: "dotted 1px var(--gray-85)",
              }}
            >
              <div className={styles.addSurveyIcon}>
                <AddSurveyModal setIsSaved={setIsSaved} />
              </div>
            </li>
          </ul>
        </div>
        <div className={styles.bottomButton}>
          <div className={styles.cancelButton}>
            <PuiButton onClick={ClickCancelButton}>キャンセル</PuiButton>
          </div>
          <div className={styles.doneButton}>
            <PuiButton onClick={ClickDoneButton} isActive={!isSaved}>
              編集完了
            </PuiButton>
          </div>
        </div>
      </div>
      {deleteIndex !== -1 && (
        <Dialog
          fullWidth={true}
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={styles.dialog}
        >
          <div style={{ display: "flex" }}>
            <ErrorIcon
              fontSize="large"
              color="secondary"
              style={{ color: "var(--red)", margin: "auto 0px auto 8px" }}
            />
            <DialogTitle
              className={classes.dialogTitle}
              id="alert-dialog-title"
            >
              アンケートを削除しますか？
            </DialogTitle>
          </div>
          {updateAllSurveyList[deleteIndex].questionList.length > 0 &&
          updateAllSurveyList[deleteIndex].questionList &&
          updateAllSurveyList[deleteIndex].questionList[0].videoIdList &&
          updateAllSurveyList[deleteIndex].questionList[0].videoIdList.length >
            0 ? (
            <DialogContent className={classes.dialogContent}>
              <DialogContentText id="alert-dialog-description">
                以下のVideoからこのアンケートが削除されます。
                <ul>
                  {updateAllSurveyList[
                    deleteIndex
                  ].questionList[0].videoIdList.map((row, index) => (
                    <li key={index}>{videos[row].title}</li>
                  ))}
                </ul>
              </DialogContentText>
            </DialogContent>
          ) : (
            <DialogContent className={classes.dialogContent}>
              <DialogContentText id="alert-dialog-description">
                現在このアンケートはどのVideoにも適用されていません。
              </DialogContentText>
            </DialogContent>
          )}
          <DialogActions className={classes.dialogActions}>
            <Button
              size="medium"
              variant="contained"
              type="submit"
              color="secondary"
              style={{ backgroundColor: "var(--red)" }}
              onClick={DeleteSurvey}
            >
              削除
            </Button>
            <Button
              size="medium"
              variant="outlined"
              type="submit"
              color="secondary"
              onClick={handleCancel}
            >
              キャンセル
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* 同じ時刻に複数件のアンケートを登録できないよう制限するメッセージ */}
      <PuiMessage
        open={isVisibleErrorMessage}
        type="error"
        title="１つの時刻には１つのアンケートのみ登録できます"
        duration={3000}
        onClose={CloseErrorMessage}
      />
    </>
  );
}

export default EditSurveyModal;
